import { Component, inject } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-preview-button',
  templateUrl: './preview-button.component.html',
  styleUrls: ['./preview-button.component.scss', '../base-button.scss'],
})
export class PreviewButtonComponent extends BaseButtonComponent {
  private readonly amplitudeService = inject(AnalyticsService);

  preview() {
    const wnd = window.open();
    this.apiService
      .getRecordPreview(this.record.id, this.issueDate, this.rhId)
      .subscribe({
        next: (preview) => {
          wnd.location.href = preview.previewUrl;
          this.amplitudeService.sendUserActionEvent('preview', true);
        },
        error: () => this.amplitudeService.sendUserActionEvent('preview', false),
      });
  }
}
